import { createLogger } from 'lbs-pi-handy/src/general-purpose/logger';
import us from './defines';
import {translate} from 'shared/services/I18nService';
const $t = translate.scope('uScope.others.viewLayout');

const logger = createLogger('UScope:ViewLayout');

// ________________________________________________________________________________________________
// viewLayout.js
//    This file contains ViewLayout,    an object that provides arrangements of viewport panes for multi-image viewing.
//
//    history
//    1106    cperz        created
//
//    _______________________________________end_AIHv1/PR __________________________________________
//    141118    cperz        moved from layout.js
//
// ________________________________________________________________________________________________
//    Object Name: ViewLayout
//    Overview: todo
//
//    Associated Panel: o todo
//
//    Dependencies and Supporting objects:
//        o jquery plugin 'layout'
//            - reference:     http://layout.jquery-dev.net/index.cfm
//            - https://groups.google.com/forum/#!topic/jquery-ui-layout/71vyVOrngfc //  options example
//            If changes need to be made to the fundamental structure of the layout,
//            you could use methods like removePane() and addPane() to change a single pane,
//            or you could destroy() the entire layout and then recreate it with completely new options.
//            This normally happens so quickly that you would not even see it, except for any changes you have specified.
//
//    Assumptions: o todo
//
//    Limitations: o todo
//
//    Terms Used: o todo
//
//    Functionality: o todo
//
//    Data Structures: o todo
//
//    HTML: o todo
//
//    References: o http://layout.jquery-dev.net/index.cfm
//
//
//    construction parameters:
//        jParentDiv
//        crContainer
//        nImages: number of images/views
//        cb_onResizeRef
//        opt_paneDesc: one of the choices for the arrangement in us.viewLayoutMode[imgCount][]
//
//    Notes:
//        after construction, check this.status
export default function cViewLayout (jParentDiv, crContainer, nImages, cb_onResizeRef, opt_paneDesc) {
  var self = this;
  this.status = true;

  var jContainer; // div created on construction that contains this layout
  var myLayout_; //
  var state = []; // array of size imageCount, each slot contains the following assoc array:
  //    {
  //        divId:            id of the pane's div
  //        jPane:            jquery object ref to the pane
  //        samplePref:        pane's preference for sample type - not currently used by mapImagesToPanes()
  //        imageIdx:        related index into jsonList used to assign images
  //
  //        sampleType:        image's sample type
  //        jImgDiv:        attached jquery object of the image's viewport; if == undefined, the image is not present
  //        imageId:        image's id (prefixed with '@')
  //    }

  // view layout settings

  var viewLayoutMode = []; // viewLayoutMode[imageCount][paneDesc_]
  viewLayoutMode[1] = ['1']; // note that the paneDesc_ text match suffixes of the corresponding toolbar icon
  viewLayoutMode[2] = ['v', 'h']; //        so don't change these assignments without considering that impact
  viewLayoutMode[3] = ['t', 'v', 'h'];
  viewLayoutMode[4] = ['4'];

  var imageCount = 0; // # of images = # of panes; constrained by max allowed
  var paneDesc_; // description of the pane layout
  var minSize = 100; // minimum pane width/height on resizer drag in pixels

  // ............................................ construct_() local
  // This function constructs the layout html and attaches it to the DOM, initializes the layout options
  //    and sizes the layout container to fill the passed jParentDiv.
  var construct_ = function () {
    imageCount = Math.min(nImages, us.multiSpecs.maxImages); // # of images = # of panes; constrained by max allowed
    if (imageCount < 1) {
      self.status = false;
      logger.error('Error: ViewLayout: construction: illegal image count: ' + imageCount);
      return;
    }
    paneDesc_ = (opt_paneDesc) || viewLayoutMode[imageCount][0]; // otherwise select the first as the default layout for this arrangement

    var layoutName = self.getLayoutName(); // create a container and attach to parent element
    jContainer = $('<div/>', {'id': layoutName}); // will have class .ui-layout-container added to it
    jParentDiv.append(jContainer);

    var html = buildContainerHTML_(); // define panes for this number of images
    jContainer.append($(html)); // inject panes into jContainer
    var options = buildOptions_(cb_onResizeRef, crContainer); // define the layout options: proportional size of the panes, minsize, resize callbacks, ...
    myLayout_ = jContainer.layout(options); // perform the layout and sizes the panes in pixels
  };

    // ............................................ accessor fns public
  this.getImageCount = function () {
    return imageCount;
  };
  this.getPaneDesc = function () {
    return paneDesc_;
  }; // return the pane descriptions (e.g. "v", "h", "t")
  this.getImageState = function (paneIdx) {
    return state[paneIdx];
  }; // return the image state assoc array for the given pane

  this.detatchFromDom = function () { // detach conataining element from the DOM
    if (jContainer) jContainer.detach();
  };

  // ............................................ getLayoutName() public
  //    This function provides a unique and descriptive name for each layout.
  //
  //    todo: should generalize this to use the viewLayoutMode array contents.
  this.getLayoutName = function () {
    if (imageCount == 1 || imageCount == 4) {
      return ('viewLayout_' + imageCount);
    } else if (imageCount == 2 || imageCount == 3) {
      return ('viewLayout_' + imageCount + '_' + paneDesc_);
    } else {
      return undefined;
    }
  };
  // ............................................ getNextPaneDesc() public
  // This function returns the NEXT layout arrangement in the viewLayoutMode sequence.
  //
  //    todo: should generalize this to use the viewLayoutMode array contents.
  this.getNextPaneDesc = function () {
    var rtnDesc = '';
    if (imageCount == 2) { // us.viewLayoutMode[2] = ["v", "h"];
      rtnDesc = (paneDesc_ == 'v') ? 'h' : 'v';
    } else if (imageCount == 3) { // us.viewLayoutMode[3] = ["t", "v", "h"];
      rtnDesc = (paneDesc_ == 't') ? 'v' : (paneDesc_ == 'v') ? 'h' : 't';
    }
    return rtnDesc;
  };

  // -------------------------------------------------------------------------------------------------
  //    LAYOUT CONFIGURATION FUNCTIONS
  // -------------------------------------------------------------------------------------------------

  // ............................................ mapImagesToPanes() local
  //    This function maps the index of an image in jsonList to the state[pane] it is to be rendered in.
  //    The pane preference for positive and negative controls samples are implemented for each layout.
  //
  //    note:    If the jsonList has more than 1 positive control (or more than 1 negative control)
  //            those additional controls are treated as patient samples with no pane preference.
  //
  //    note:  The state[]'s samplePref are not yet filled in, if they were this fn could obey the
  //            prefered pane location for controls.  Right now the preference panes for controls is
  //            just coded in.

  var mapImagesToPanes = function (jsonList) {
    // ..................................................
    //    This function identifies the first image in the jsonList of the given sample type
    //    and returns that index into the jsonList or -1 if not found.
    var findSampleTypeIdx = function (jsonList, sampleType) {
      for (var i = 0; i < imageCount; i++) {
        if (sampleType == jsonList[i].sampleType) { return i; }
      }
      return -1;
    };
    // ..................................................
    //    This function ...
    var assignPatientSamples = function () {
      for (var i = 0; i < imageCount; i++) { // then assign patient sample types
        if (jsonList[i].assigned == false) { // find unassigned image
          for (var p = 0; p < imageCount; p++) {
            if (state[p].imageIdx == undefined) { // assign it to the first empty pane
              state[p].imageIdx = i;
              jsonList[i].assigned = true;
              break;
            }
          }
        }
      }
    };
    // ..................................................
    for (var i = 0; i < imageCount; i++) { // set all images unassigned to a pane
      jsonList[i].assigned = false;
    }

    var posIdx = findSampleTypeIdx(jsonList, 'positive'); // identify the 1st positive and 1st negative control imgaes
    var negIdx = findSampleTypeIdx(jsonList, 'negative');
    if (posIdx != -1) jsonList[posIdx].assigned = true;
    if (negIdx != -1) jsonList[negIdx].assigned = true;

    if (imageCount == 1) { // for each layout configuration, place the controls then the patient samples
      state[0].imageIdx = 0;
    } else if (imageCount == 2) {
      if (posIdx != -1 && negIdx != -1) {
        state[0].imageIdx = posIdx;
        state[1].imageIdx = negIdx;
      } else if (posIdx != -1) {
        state[0].imageIdx = (posIdx == 0) ? 1 : 0;
        state[1].imageIdx = posIdx;
      } else if (negIdx != -1) {
        state[0].imageIdx = (negIdx == 0) ? 1 : 0;
        state[1].imageIdx = negIdx;
      } else {
        state[0].imageIdx = 0;
        state[1].imageIdx = 1;
      }
    } else if (imageCount == 3) {
      if (paneDesc_ == 't' || // assign pos and neg controls first
                (posIdx != -1 && negIdx != -1)) {
        if (posIdx != -1) {
          state[1].imageIdx = posIdx;
        }
        if (negIdx != -1) {
          state[2].imageIdx = negIdx;
        }
      } else {
        if (posIdx != -1) {
          state[2].imageIdx = posIdx;
        }
        if (negIdx != -1) {
          state[2].imageIdx = negIdx;
        }
      }
      assignPatientSamples(); // then the other images in the list
    } else if (imageCount == 4) {
      if (posIdx != -1 && negIdx != -1) { // assign pos and neg controls first
        if (posIdx != -1) {
          state[2].imageIdx = posIdx;
        }
        if (negIdx != -1) {
          state[3].imageIdx = negIdx;
        }
      } else {
        if (posIdx != -1) {
          state[3].imageIdx = posIdx;
        }
        if (negIdx != -1) {
          state[3].imageIdx = negIdx;
        }
      }
      assignPatientSamples(); // then the other images in the list
    }
  };

    // ............................................ append() public
    // This function appends, assigns the passed image divs in the newly constructed layout panes.
  this.append = function (jsonList) {
    if (self.status == false) return false;

    if (jsonList.length != imageCount) {
      logger.error('Error: ViewLayout: append: incorrect input list length');
      return false;
    }

    mapImagesToPanes(jsonList);

    for (var p = 0; p < imageCount; p++) {
      var imageIdx = state[p].imageIdx;
      var imageInfo = jsonList[imageIdx];

      var jPane = $(us.idHashROOT).find('#' + state[p].divId);
      jPane.append(imageInfo.jImgDiv);
      paneStateUpdate(p, jPane, imageInfo.imageId, imageInfo.sampleType, imageInfo.jImgDiv); // todo? pass imageInfo and let pane update choose what it wants??
    }

    return true;
  };
  // ............................................ stateChange() public
  // This function xxxx pane in this layout.
  this.stateChange = function (imageId, typeName, typeValue) {
    var idxPane = paneIdxFind('imageId', imageId);
    if (idxPane == -1) {
      logger.error('Error: ViewLayout: stateChange: image not found: imageId: ' + imageId);
      return false;
    }

    if (typeName == 'sampleType') { state[idxPane].sampleType = typeValue; }

    return idxPane;
  };
  // ............................................ remove() public
  // This function removes an image from its pane in this layout.
  this.remove = function (imageId) {
    var idxPane = paneIdxFind('imageId', imageId);
    if (idxPane == -1) {
      logger.error('Error: ViewLayout: remove: image not found: imageId: ' + imageId);
      return false;
    }

    var jImgDiv = state[idxPane].jImgDiv;
    jImgDiv.detach();

    state[idxPane].jImgDiv = undefined; // indicates that the image is no longer appended

    return idxPane;
  };
  // ............................................ replace() public
  // This function replaces an image in its pane with another.
  this.replace = function (imageId, jsonItem) {
    if (self.status == false) return false;

    var idxPane = this.remove(imageId);
    if (idxPane == -1) return false;

    var jPane = state[idxPane].jPane;
    jPane.append(jsonItem.jImgDiv);
    paneStateUpdate(idxPane, jPane, jsonItem.imageId, jsonItem.sampleType, jsonItem.jImgDiv);

    return true;
  };

  // ............................................ compress() public
  // This function moves the images in the passed layout into this layout.
  //    It is typically called on
  //    - when the panes are reconfigured due to the removal of an image
  //    - or when the panes are reconfigured due to the user initiated layout change (3 't' to 3 'v' for instance)

  this.compress = function (curLayout) {
    if (self.status == false) return false;

    curLayout.detatchFromDom(); // current layout is being replaced with new
    var jsonList = curLayoutToJsonList(curLayout);
    return this.append(jsonList);
  };
  // ............................................ expand() public
  // This function moves the images in the passed layout into this layout and adds new images.
  this.expand = function (curLayout, jsonList) {
    if (self.status == false) return false;

    curLayout.detatchFromDom(); // current layout is being extended
    var jsonList2 = curLayoutToJsonList(curLayout); //
    jsonList = jsonList2.concat(jsonList); //
    return this.append(jsonList); //
  };

  // ............................................ curLayoutToJsonList() local
  var curLayoutToJsonList = function (curLayout) {
    var jsonList = [];

    var priorImageCount = curLayout.getImageCount(); // # images moving to this layout
    for (var i = 0; i < priorImageCount; i++) {
      var aState = curLayout.getImageState(i);
      if (aState.jImgDiv != undefined) { jsonList.push({imageId: aState.imageId, sampleType: aState.sampleType, jImgDiv: aState.jImgDiv}); }
    }
    return jsonList;
  };

    // ............................................ onResize() public
    // This function recomputes the maximum pane size such that adjacent views' minimum size is respected.
    //    It is called when the browser resizes.
    //
    //    params:
    //        crContainer: the size in a Rectangle of the layout container div

  this.onResize = function (crContainer) {
    if (self.status == false) return false;
    var containWidth = crContainer.w;
    var containHeight = crContainer.h;

    myLayout_.resizeAll(); // insures that when DST collapses/expands the layout constainer's dims is updated

    if (imageCount == 1) {
    } else if (imageCount == 2) {
      if (paneDesc_ == 'v') {
        myLayout_.options.east.maxSize = containWidth - minSize;
      } else {
        myLayout_.options.east.maxSize = containHeight - minSize;
      }
    } else if (imageCount == 3) {
      if (paneDesc_ == 't') {
        myLayout_.options.east.maxSize = containWidth - minSize;
        myLayout_.options.south.maxSize = containHeight - minSize;
      } else if (paneDesc_ == 'v') {
        // todo: not quite right for center pane - can get too small
        myLayout_.options.east.maxSize = containWidth - 2 * minSize;
        myLayout_.options.west.maxSize = containWidth - 2 * minSize;
      } else {
        // todo: not quite right for center pane - can get too small
        myLayout_.options.north.maxSize = containHeight - 2 * minSize;
        myLayout_.options.south.maxSize = containHeight - 2 * minSize;
      }
    } else if (imageCount == 4) {
      // todo: not quite right after resize for move horiz up when increse window or decrease window
      myLayout_.options.center.maxSize = containWidth - minSize;
      myLayout_.options.east.maxSize = containWidth - minSize;
      myLayout_.options.south.maxSize = containHeight - minSize;
    }
  };

  // -------------------------------------------------------------------------------------------------
  //    HTML AND OPTIONS FUNCTIONS
  // -------------------------------------------------------------------------------------------------
  // ............................................ buildOptions_() local
  // This function builds the option string that defines the pane features for the layout such as
  //    its minimum size, callbacks when the resizer is dragged, ...
  //
  //    params:
  //        cb_onResize:
  //        crContainer: Rectangle of containter
  //
  //    notes:
  //    - onresize_end fires when a pane is resized, not the browser window
  //    - size is the initial size proportion (e.g. 0.5 is 50%)
  //    - center panes minSize can't be set so the other panes' maxSize provides for the center pane's minSize
  //    - closable true/false enables/disables visibility and operation of pane togglers
  //
  var buildOptions_ = function (cb_onResize, crContainer) {
    var options = {};
    var containWidth = crContainer.w;
    var containHeight = crContainer.h;
    var layoutName = self.getLayoutName();

    var closable = true;
    var spacing_closed = 10;

    if (imageCount == 1) {
      options = {
        name: layoutName, onresize_end: cb_onResize, onclose: cb_onResize, minSize: minSize, closable: false
        /// /, enableCursorHotkey: false //////test
      };
    } else if (imageCount == 2) {
      if (paneDesc_ == 'v') {
        options = {
          name: layoutName,
          onresize_end: cb_onResize,
          onopen: cb_onResize,
          onclose: cb_onResize,
          minSize: minSize,
          closable: closable,
          spacing_open: 6,
          spacing_closed: spacing_closed, // ALL panes

          east: {
            name: layoutName,
            onresize_end: cb_onResize,
            onopen: cb_onResize,
            onclose: cb_onResize,
            minSize: minSize,
            maxSize: (containWidth - minSize),
            size: 0.5
          }
        };
      } else {
        options = {
          name: layoutName,
          onresize_end: cb_onResize,
          onopen: cb_onResize,
          onclose: cb_onResize,
          minSize: minSize,
          closable: closable,
          spacing_open: 6,
          spacing_closed: spacing_closed, // ALL panes

          south: {
            name: layoutName,
            onresize_end: cb_onResize,
            onopen: cb_onResize,
            onclose: cb_onResize,
            minSize: minSize,
            maxSize: (containHeight - minSize),
            size: 0.5
          }
        };
      }
    } else if (imageCount == 3) {
      if (paneDesc_ == 't') {
        options = {
          name: layoutName,
          onresize_end: cb_onResize,
          onopen: cb_onResize,
          onclose: cb_onResize,
          minSize: minSize,
          east__size: 0.33,
          maxSize: (containWidth - minSize),
          closable: closable,
          spacing_open: 6,
          spacing_closed: spacing_closed, // ALL panes

          east__children: {
            name: layoutName,
            onresize_end: cb_onResize, // insures pulling north/south divider down resizes north
            south: {
              name: layoutName,
              onresize_end: cb_onResize,
              onopen: cb_onResize,
              onclose: cb_onResize,
              minSize: minSize,
              maxSize: (containHeight - minSize),
              size: 0.5
            }
          }
        };
      } else if (paneDesc_ == 'v') {
        options = {
          name: layoutName,
          onresize_end: cb_onResize,
          onopen: cb_onResize,
          onclose: cb_onResize,
          minSize: minSize,
          maxSize: (containWidth - 2 * minSize),
          closable: closable,
          spacing_open: 6,
          spacing_closed: spacing_closed, // ALL panes
          east: {
            name: layoutName,
            onresize_end: cb_onResize,
            onopen: cb_onResize,
            onclose: cb_onResize,
            minSize: minSize,
            size: 0.33,
            closable: closable,
            spacing_closed: spacing_closed
          },
          west: {
            name: layoutName,
            onresize_end: cb_onResize,
            onopen: cb_onResize,
            onclose: cb_onResize,
            minSize: minSize,
            maxSize: (containWidth - 2 * minSize),
            size: 0.33,
            closable: closable,
            spacing_closed: spacing_closed
          }
        };
      } else {
        options = {
          name: layoutName,
          onresize_end: cb_onResize,
          onopen: cb_onResize,
          onclose: cb_onResize,
          minSize: minSize,
          maxSize: (containHeight - 2 * minSize),
          closable: closable,
          spacing_open: 6,
          spacing_closed: spacing_closed, // ALL panes

          north: {
            name: layoutName,
            onresize_end: cb_onResize,
            onopen: cb_onResize,
            onclose: cb_onResize,
            minSize: minSize,
            size: 0.33
          },
          south: {
            name: layoutName,
            onresize_end: cb_onResize,
            onopen: cb_onResize,
            onclose: cb_onResize,
            minSize: minSize,
            maxSize: (containHeight - 2 * minSize),
            size: 0.33
          }
        };
      }
    } else if (imageCount == 4) {
      options = {
        name: layoutName,
        onresize_end: cb_onResize,
        onopen: cb_onResize,
        onclose: cb_onResize,
        minSize: minSize,
        maxSize: (containWidth - minSize),
        east__size: 0.5,
        closable: closable,
        spacing_open: 6,
        spacing_closed: spacing_closed, // ALL panes

        center__children: {
          name: layoutName,
          onresize_end: cb_onResize,
          onopen: cb_onResize,
          onclose: cb_onResize,
          minSize: minSize,
          maxSize: (containHeight - minSize),
          south__size: 0.5
        },
        east__children: {
          name: layoutName,
          onresize_end: cb_onResize, // insures pulling north/south divider down resizes north
          south: {
            onresize_end: cb_onResize,
            onopen: cb_onResize,
            onclose: cb_onResize,
            minSize: minSize,
            maxSize: (containHeight - minSize),
            size: 0.5
          }
        }
      };
    }
    /// /////////////////////////////////////// not working for all views!
    options.togglerTip_open = $t('hide-view');
    options.togglerTip_closed = $t('show-view');
    options.resizerTip = $t('drag-resize-views');
    options.sliderTip = $t('drag-show-view');
    /// ///////////////////////////////////////

    return options;
  };

    // ............................................ buildContainerHTML_() local
    // This function builds the html string that defines the layout panes as a function of imageCount.
    //    It initializes the state array with the pane id.

  var buildContainerHTML_ = function () {
    var html = '';
    if (imageCount == 1) {
      state[0] = paneStateInit('us_centerpane', 'none');
      html = '<div class="ui-layout-center"     id="us_centerpane">patient sample1</div>';
    } else if (imageCount == 2) {
      if (paneDesc_ == 'v') {
        state[0] = paneStateInit('us_leftpane', 'none');
        state[1] = paneStateInit('us_rightpane', 'none');

        html = '<div class="ui-layout-center" id="us_leftpane">patient sample1</div>' +
                    '<div class="ui-layout-east"   id="us_rightpane">patient sample2</div>';
      } else { // "h"
        state[0] = paneStateInit('us_toppane', 'none');
        state[1] = paneStateInit('us_bottompane', 'none');

        html = '<div class="ui-layout-center" id="us_toppane">patient sample1</div>' +
                    '<div class="ui-layout-south"  id="us_bottompane">patient sample2</div>';
      }
    } else if (imageCount == 3) {
      if (paneDesc_ == 't') {
        state[0] = paneStateInit('us_leftpane', 'none');
        state[1] = paneStateInit('us_toprightpane', 'none');
        state[2] = paneStateInit('us_bottomrightpane', 'none');

        html = '<div class="ui-layout-center"  id="us_leftpane">patient sample</div>' +
                    '<div class="ui-layout-east"><b><u>Outer East</u></b>' + // right side pane (east of center)
                    '<div class="ui-layout-center"  id="us_toprightpane">posControl</div>' +
                    '<div class="ui-layout-south"   id="us_bottomrightpane">negControl</div>';
      } else if (paneDesc_ == 'v') {
        state[0] = paneStateInit('us_leftpane', 'none');
        state[1] = paneStateInit('us_centerpane', 'none');
        state[2] = paneStateInit('us_rightpane', 'none');

        html = '<div class="ui-layout-west"    id="us_leftpane">patient sample1</div>' +
                    '<div class="ui-layout-center"  id="us_centerpane">patient sample2</div>' +
                    '<div class="ui-layout-east"    id="us_rightpane">patient sample3</div>';
      } else { // "h"
        state[0] = paneStateInit('us_toppane', 'none');
        state[1] = paneStateInit('us_centerpane', 'none');
        state[2] = paneStateInit('us_bottompane', 'none');

        html = '<div class="ui-layout-north"  id="us_toppane">patient sample1</div>' +
                    '<div class="ui-layout-center" id="us_centerpane">patient sample2</div>' +
                    '<div class="ui-layout-south"  id="us_bottompane">patient sample3</div>';
      }
    } else if (imageCount == 4) {
      state[0] = paneStateInit('us_topleftpane', 'none');
      state[1] = paneStateInit('us_bottomleftpane', 'none');
      state[2] = paneStateInit('us_toprightpane', 'none');
      state[3] = paneStateInit('us_bottomrightpane', 'none');

      html = '<div class="ui-layout-center">patient sample' +
                '<div class="ui-layout-center"  id="us_topleftpane">top left</div>' +
                '<div class="ui-layout-south"   id="us_bottomleftpane">bottom left</div>' +
                '</div>' +
                '<div class="ui-layout-east"><b><u>Outer East</u></b>' +// right side pane (east of center)
                '<div class="ui-layout-center"  id="us_toprightpane">northeast</div>' +
                '<div class="ui-layout-south"   id="us_bottomrightpane">southeast</div>' +
                '</div>';
    }
    return html;
  };
    // -------------------------------------------------------------------------------------------------
    //    STATE ARRAY HELPERS
    // -------------------------------------------------------------------------------------------------
    // ............................................ buipaneStateInitldHTML() local
    // This function returns an initialized pane object for the state array.
  var paneStateInit = function (divId, pref) {
    return {
      divId: divId,
      samplePref: pref,
      imageIdx: undefined,
      jPane: undefined,
      sampleType: undefined,
      imageId: undefined,
      jImgDiv: undefined
    };
  };
    // ............................................ paneStateUpdate() local
    // This function updates a specific pane object in the state array.
  var paneStateUpdate = function (idx, jPane, imageId, sampleType, jImgDiv) {
    state[idx].jPane = jPane; // save a ref to the pane's div

    state[idx].imageId = imageId; // save the image's id
    state[idx].sampleType = sampleType; // save the image's sample type
    state[idx].jImgDiv = jImgDiv; // save a ref to the appended image's div
  };
    // ............................................ paneIdxFind() local
    // This function finds the index in the state array with the key value specified
    //    or -1 if the key value pair doesn't exist in the state array.
  var paneIdxFind = function (key, value) {
    for (var s = 0; s < imageCount; s++) {
      if (state[s][key] == value) { return s; }
    }
    return -1;
  };

    // ............................................ construction
  construct_();
}
// ________________________________________________________________________________________________
